export enum Rating {
  verde = 'verde',
  amarillo = 'amarillo',
  rojo = 'rojo',
}

export function starsToRating(stars: number): Rating {
  switch (stars) {
    case 3:
      return Rating.verde;
    case 2:
      return Rating.amarillo;
    default:
      return Rating.rojo;
  }
}

export function ratingToStars(rating?: Rating): number {
  if (!rating) return 0;
  switch (rating) {
    case Rating.verde:
      return 3;
    case Rating.amarillo:
      return 2;
    case Rating.rojo:
      return 1;
  }
}
